export enum YesNo {
  Yes = 'yes',
  No = 'no',
}

export default YesNo;
